import type { VAxios } from '../../define/axios/Axios';

/**
 * 反馈相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  feedbackAbility: (params) => {
    return defHttp.post({
      url: `/aiad/feedbacks/ability`,
      params,
    });
  },

  feedbackStyle: (params) => {
    return defHttp.post({
      url: `/aiad/feedbacks/style`,
      params,
    });
  },

  applyBeta: (params) => {
    return defHttp.post({
      url: `/aiad/feedbacks/beta`,
      params,
    });
  },
});
